// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `button.styles_btn_base__shXxX {
  text-transform: unset;
  cursor: pointer;
  transition: 0.5s all;
  font-weight: 600;
  font-size: 1.125rem;
  border-radius: 0.5rem; }
  @media (max-width: 1700px) {
    button.styles_btn_base__shXxX {
      font-size: 1.5rem; } }
  @media (max-width: 1500px) {
    button.styles_btn_base__shXxX {
      font-size: 1.25rem; } }

button.styles_link__DKFSo {
  padding: unset;
  margin: unset;
  font-size: unset;
  font-weight: 500; }
  button.styles_link__DKFSo:hover {
    opacity: 0.9;
    background-color: unset; }

button.styles_grey__etzrH, button.styles_grey-blue__HE8mY {
  color: #808080;
  opacity: 0.9;
  color: #808080; }
  button.styles_grey__etzrH:hover, button.styles_grey-blue__HE8mY:hover {
    opacity: 0.9; }

button.styles_grey-bg__Hm11D {
  color: #fff;
  opacity: 0.9;
  background-color: #808080b8; }
  button.styles_grey-bg__Hm11D:hover {
    opacity: 0.9;
    color: #3c3b3b; }

button.styles_ocean-blue__92rWc {
  color: #1976d2b8;
  opacity: 0.9; }
  button.styles_ocean-blue__92rWc.styles_hover__uIiNP:hover {
    color: #1976d2e6; }
  button.styles_ocean-blue__92rWc:active {
    color: #1976d2e6; }

button.styles_grey-blue__HE8mY.styles_hover__uIiNP:hover {
  color: #72abab;
  opacity: 1;
  background-color: #73abab1a; }

button.styles_grey-blue__HE8mY.styles_active__WLLq- {
  color: #72abab;
  opacity: 1; }

button.styles_none__yADNY {
  color: unset; }
  button.styles_none__yADNY.styles_hover__uIiNP:hover {
    color: unset;
    opacity: 1;
    background-color: none; }
  button.styles_none__yADNY:active {
    color: unset;
    opacity: 1;
    background-color: none; }
`, "",{"version":3,"sources":["webpack://./src/modules/Core/sub-modules/ui-kit/components/Button/styles.module.scss","webpack://./src/modules/Core/styles/mixins.scss","webpack://./src/modules/Core/styles/variables.scss"],"names":[],"mappings":"AAGA;EACE,qBAAqB;EACrB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB,EAAA;ECPrB;IDCF;MAQI,iBAAiB,EAAA,EAMpB;ECfC;IDCF;MAYI,kBAAkB,EAAA,EAErB;;AAED;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,gBAAgB,EAAA;EAJlB;IAMI,YAAY;IACZ,uBAAuB,EAAA;;AAI3B;EACE,cEZY;EFaZ,YAAY;EACZ,cEdY,EAAA;EFWd;IAKI,YAAY,EAAA;;AAIhB;EACE,WAAW;EACX,YAAY;EACZ,2BEzBgB,EAAA;EFsBlB;IAKI,YAAY;IACZ,cAAc,EAAA;;AAIlB;EACE,gBEfmB;EFgBnB,YAAY,EAAA;EAFd;IAKM,gBEpBe,EAAA;EFerB;IASI,gBExBiB,EAAA;;AF4BrB;EAIM,cE3Bc;EF4Bd,UAAU;EACV,2BExBkB,EAAA;;AFkBxB;EAUI,cEjCgB;EFkChB,UAAU,EAAA;;AAGd;EACE,YAAY,EAAA;EADd;IAIM,YAAY;IACZ,UAAU;IACV,sBAAsB,EAAA;EAN5B;IAUI,YAAY;IACZ,UAAU;IACV,sBAAsB,EAAA","sourcesContent":["@import \"src/modules/Core/styles/variables.scss\";\n@import \"src/modules/Core/styles/mixins.scss\";\n\nbutton.btn_base {\n  text-transform: unset;\n  cursor: pointer;\n  transition: 0.5s all;\n  font-weight: 600;\n  font-size: 1.125rem;\n  border-radius: 0.5rem;\n  @include respond-to(1700px) {\n    font-size: 1.5rem;\n  }\n\n  @include respond-to(1500px) {\n    font-size: 1.25rem;\n  }\n}\n\nbutton.link {\n  padding: unset;\n  margin: unset;\n  font-size: unset;\n  font-weight: 500;\n  &:hover {\n    opacity: 0.9;\n    background-color: unset;\n  }\n}\n\nbutton.grey {\n  color: $grey;\n  opacity: 0.9;\n  color: $grey;\n  &:hover {\n    opacity: 0.9;\n  }\n}\n\nbutton.grey-bg {\n  color: #fff;\n  opacity: 0.9;\n  background-color: $grey72;\n  &:hover {\n    opacity: 0.9;\n    color: #3c3b3b;\n  }\n}\n\nbutton.ocean-blue {\n  color: $ui_blue72;\n  opacity: 0.9;\n  &.hover {\n    &:hover {\n      color: $ui_blue90;\n    }\n  }\n  &:active {\n    color: $ui_blue90;\n  }\n}\n\nbutton.grey-blue {\n  @extend .grey;\n  &.hover {\n    &:hover {\n      color: $ocean_blue;\n      opacity: 1;\n      background-color: $ocean_blue10;\n    }\n  }\n  &.active {\n    color: $ocean_blue;\n    opacity: 1;\n  }\n}\nbutton.none {\n  color: unset;\n  &.hover {\n    &:hover {\n      color: unset;\n      opacity: 1;\n      background-color: none;\n    }\n  }\n  &:active {\n    color: unset;\n    opacity: 1;\n    background-color: none;\n  }\n}\n","// @import \"src/modules/Core/styles/mixins.scss\";\n@mixin respond-to($breakpoint) {\n  @media (max-width: $breakpoint) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 768px) {\n    @content;\n  }\n}\n\n@mixin multilineText($lines){\n  -webkit-line-clamp: $lines;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  display: -webkit-box;\n}","// @import \"src/modules/Core/styles/variables.scss\";\n\n$white90: #ffffffe6;\n$green50: #00800080;\n\n$white10: #ffffff1a;\n$white18: #ffffff2e;\n$white50: #ffffff80;\n\n$grey3:#80808008;\n$grey5: #8080800d;\n$grey7: #80808012;\n$grey10: #8080801a;\n$grey18: #8080802e;\n$grey36: #8080805c;\n$grey50: #80808080;\n$grey54: #8080808a;\n$grey72: #808080b8;\n$grey90: #808080e6;\n$grey: #808080;\n\n\n$purple100: #800080;\n$purple90: #800080e6;\n$purple72:#800080b8;\n$purple50: #80008080;\n$purple36: #8000805c;\n$purple18: #8000802e;\n\n$dark_purple: #480048;\n$deep_purple: #840000;\n\n$baby_blue: #87ceeb;\n$ui_blue: #1976d2;\n$ui_blue90: #1976d2e6;\n$ui_blue72: #1976d2b8;\n$ui_blue50: #1976d280;\n$pond_green: #72bbbb;\n$pond_green72: #72bbbbb8;\n$ocean_blue: #72abab;\n$ocean_blue90: #72ababe6;\n$ocean_blue72: #72ababb8;\n$ocean_blue50: #72abab80;\n$ocean_blue36: #72abab5c;\n$ocean_blue10: #73abab1a;\n$kermit_green: #72ab72;\n$kermit_green72: #72ab72b8;\n$somewhat_certain:#183672;\n$just_say_ok: #721446;\n$success_street: #723618;\n\n$golden: #ffd700;\n$_golden: #D4AF37;\n$bronze: #cd7f32;\n\n$bronze80: #cd7f32c2;\n$bronze50: #cd7f3280;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"btn_base": `styles_btn_base__shXxX`,
	"link": `styles_link__DKFSo`,
	"grey": `styles_grey__etzrH`,
	"grey-blue": `styles_grey-blue__HE8mY`,
	"grey-bg": `styles_grey-bg__Hm11D`,
	"ocean-blue": `styles_ocean-blue__92rWc`,
	"hover": `styles_hover__uIiNP`,
	"active": `styles_active__WLLq-`,
	"none": `styles_none__yADNY`
};
export default ___CSS_LOADER_EXPORT___;
